import React, { useCallback } from 'react';

/**
 * KDS card with a pointer-following highlight. Purely cosmetic: content,
 * hover affordance and focus styles do not depend on the effect, and the
 * gradient is suppressed entirely under prefers-reduced-motion.
 */
export default function SpotlightCard({ as: Tag = 'div', className = '', children, onPointerMove, ...rest }) {
  const handlePointerMove = useCallback(
    (event) => {
      const rect = event.currentTarget.getBoundingClientRect();
      event.currentTarget.style.setProperty('--kds-spot-x', `${event.clientX - rect.left}px`);
      event.currentTarget.style.setProperty('--kds-spot-y', `${event.clientY - rect.top}px`);
      if (onPointerMove) onPointerMove(event);
    },
    [onPointerMove]
  );

  return (
    <Tag
      className={`kds-card kds-card--interactive kds-spotlight ${className}`.trim()}
      onPointerMove={handlePointerMove}
      {...rest}
    >
      {children}
    </Tag>
  );
}
